export default __webpack_public_path__ + "static/media/kiddy.c53a28d0.webp";